export default __webpack_public_path__ + "static/new8-05-358a8230fdd80e95282ef565a84ed70f.jpg";